import React from 'react'
import ReactTimeAgo from 'react-timeago'

const TimeAgo = ({ date, minPeriod, ...restProps }) => (
  <ReactTimeAgo date={date} minPeriod={minPeriod} {...restProps} />
)

TimeAgo.defaultProps = {
  minPeriod: 60,
}

export default TimeAgo



// WEBPACK FOOTER //
// ./src/components/common/TimeAgo.jsx